import { useMutation } from '@tanstack/react-query';

import updatePassword from './updatePassword';

export default function useEditPassword() {
  return useMutation({
    mutationKey: ['edit-password'],
    mutationFn: ({ password, token }) => {
      return updatePassword({ password, token });
    },
  });
}
